/**
 * Normalizes the n from the range [start, stop]
 * e.g. map(100, 0, 200) => 0.5
 */
export function norm(n: number, start: number, stop: number): number {
  return (n - start) / (stop - start);
}
